import { testimonials } from "@/mocks/categories";

const avatarImages = [
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20stylish%20streetwear%20jacket%2C%20warm%20golden%20hour%20background%2C%20soft%20natural%20lighting%2C%20friendly%20confident%20expression%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-marcus&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20woman%20with%20elegant%20minimalist%20style%2C%20urban%20cafe%20background%2C%20soft%20window%20lighting%2C%20warm%20genuine%20smile%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-elena&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20casual%20denim%20style%2C%20brick%20wall%20background%2C%20natural%20outdoor%20lighting%2C%20relaxed%20confident%20expression%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-david&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20woman%20with%20bohemian%20style%2C%20garden%20background%20with%20soft%20bokeh%2C%20warm%20natural%20lighting%2C%20bright%20friendly%20smile%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-sophie&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20modern%20business%20casual%20style%2C%20office%20interior%20background%2C%20soft%20natural%20lighting%2C%20professional%20approachable%20expression%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-alex&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20creative%20artsy%20style%2C%20colorful%20studio%20background%2C%20soft%20diffused%20lighting%2C%20playful%20genuine%20smile%2C%20modern%20portrait%20photography&width=100&height=100&seq=avatar-v2-liam&orientation=squarish",
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-quote-line"></i>
            Community Reviews
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-4">
            Trusted by Thousands
            <br />
            of Fashion Shoppers
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto leading-relaxed">
            Real feedback from real pandabuyspreadsheet users who found their best deals through our
            curated hub.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className="rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < t.rating ? "ri-star-fill text-amber-400" : "ri-star-line text-foreground-200"
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-5">{t.text}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={avatarImages[idx]}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-400 whitespace-nowrap">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}